import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip, Typography, Button } from '@mui/material';
import { Page, Row, Fill } from '../util/Page';
import ExportsTable from './ExportsTable';

const Exports = () => (
  <div style={{ display: 'grid' }}>
    <Page>
      <Row>
        <Typography variant="h5" className="page-title">
          Export Timeseries Data
        </Typography>
        <Fill />
        <Tooltip title="Define a new timeseries data export by selecting sensors and a time range to query">
          <Button component={Link} className="nav-button" to="/exports/new">
            Create New Export
          </Button>
        </Tooltip>
      </Row>
    </Page>
    <Page>
      <Row>
        <Typography variant="h5" align="left">
          Your Exports
        </Typography>
      </Row>
      <Row>
        <ExportsTable />
      </Row>
    </Page>
  </div>
);

export default Exports;
